import { Helmet } from "react-helmet-async";

const SITE_NAME = "EV Hub Studio";
const DEFAULT_IMAGE = "https://evhubstudio.com/og-image.png";

/**
 * Drop-in per-page SEO component.
 * Usage:
 *   <PageSEO
 *     title="ROI Calculator | EV Hub Studio"
 *     description="Calculate return on investment for your EV charging station in India."
 *     path="/roi-calculator"
 *   />
 */
export default function PageSEO({ title, description, path = "", image = DEFAULT_IMAGE, noindex = false }) {
  const canonical = `https://evhubstudio.com${path}`;
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
